import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AlternativeComponent } from './alternative/alternative.component';
import { RegisterRoutingModule } from './register-routing.module';
import { RegisterComponent } from './register/register.component';


@NgModule({
  declarations: [RegisterComponent, AlternativeComponent],
  imports: [
    SharedModule,
    RegisterRoutingModule
  ]
})
export class RegisterModule { }
